import { Component } from '@angular/core';

@Component({
  selector: 'itl-desktop-list-item-status',
  template: '<ng-content></ng-content>',
})
export class DesktopListItemStatusComponent {}
